




















































































































































































































// @ts-nocheck — Vue.extend loses Data/Computed inference here (fork-ts-checker).
import Vue from 'vue'
import { LPopup } from 'vue2-leaflet'
import { postPlaceStatistic } from '@/placeStatistic'
import LunchImageCarousel from './LunchImageCarousel.vue'

const ADDRESS_LINK_URL_BASIS = 'https://www.google.com/maps/search/?api=1'
const ADDRESS_LINK_SEARCH_PHRASE_PARAMETER_KEY = 'query'

export default Vue.extend({
  props: {
    place: {
      type: Object,
      required: true
    }
  },
  components: {
    LPopup,
    LunchImageCarousel
  },
  data () {
    return {
      navigator,
      copiedURLToClipboard: undefined as undefined | null | boolean,
      addressLinkURL: new URL(ADDRESS_LINK_URL_BASIS),
    }
  },
  computed: {
    popupOptions () {
      return {
        className: 'map-information-box',
        offset: [0, 0],
        closeButton: false,
        maxWidth: this.$store.state.isLunchMap ? 360 : 300,
      }
    },
    addressLink () : string {
      this.addressLinkURL.searchParams.set(ADDRESS_LINK_SEARCH_PHRASE_PARAMETER_KEY, this.place['address'])
      return this.addressLinkURL.toString()
    },
    copyURLToClipboardButtonTooltipText () : string {
      return (this.copiedURLToClipboard ?  this.$t('copy_link_save_success')
        : this.copiedURLToClipboard === false ? this.$t('copy_link_save_failed')
          : this.$t('copy_link_message')) as string
    },
    likedPlaceButtonTooltipText () : string {
      return ((this.$store.state.likedPlaces.includes(this.place.id)) ?  this.$t('like_place_save_failed')
        : !(this.$store.state.likedPlaces.includes(this.place.id)) ? this.$t('like_place_save_success')
          : this.$t('like_place_message')) as string
    },
    leagueName() : string {
      const language = this.$store.state.currentLanguage;
      const event = this.$store.state.selectedEvent;
      if(!event.league){
        return event.league_name;
      }
      if (language){
        const nameKey = 'name_' + language;
        if(nameKey in event.league && event.league[nameKey]){
          return event.league[nameKey];
        }
      }
      return event.league['name'];
    },
    eventName() : string {
      const language = this.$store.state.currentLanguage;
      const event = this.$store.state.selectedEvent;
      if (language){
        const nameKey = 'name_' + language;
        if(nameKey in event){
          return event[nameKey];
        }
      }
      return event['name'];
    },
    isLikedPlace() : boolean {
      return this.$store.state.likedPlaces.includes(this.place.id);
    },
    visibleScheduleEvents (): any[] {
      const events = Array.isArray(this.place.schedule_events) ? this.place.schedule_events : []
      return events.slice(0, 3)
    },
    scheduleSeoUrl (): string | null {
      const alias = this.place && this.place.alias
      if (!alias || typeof alias !== 'string') {
        return null
      }
      return '/lokal/' + encodeURIComponent(alias)
    },
    latestLunchPost (): any | null {
      const posts = this.place && this.place.placelunchpost_set
      if (!Array.isArray(posts) || !posts.length) {
        return null
      }
      return posts[0]
    },
    latestLunchPostImages (): any[] {
      const post = this.latestLunchPost
      if (!post || !Array.isArray(post.placelunchpostimage_set)) {
        return []
      }
      return post.placelunchpostimage_set
    },
    latestLunchPostDateLabel (): string {
      const posts = this.place && this.place.placelunchpost_set
      if (!Array.isArray(posts) || !posts.length) {
        return ''
      }
      // iframe / PDF embeds have no meaningful menu update timestamp
      const post = posts.find((p: any) => p && !p.iframe_url && p.post_created)
      if (!post) {
        return ''
      }
      const date = new Date(post.post_created)
      if (isNaN(date.getTime())) {
        return ''
      }
      const locale = this.$store.state.currentLanguage == 'pol' ? 'pl' : 'en-US'
      return date.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      })
    },
    lunchSeoUrl (): string | null {
      const alias = this.place && this.place.alias
      if (!alias || typeof alias !== 'string') {
        return null
      }
      return '/restauracja/' + encodeURIComponent(alias)
    },
  },
  methods: {
    formatScheduleEvent (ev: any) {
      if (!ev) {
        return ''
      }
      const when = ev.from_date ? new Date(ev.from_date).toLocaleString(undefined, {
        weekday: 'short', hour: '2-digit', minute: '2-digit'
      }) : ''
      return when ? `${when} — ${ev.name}` : ev.name
    },
    copyURLToClipboard () {
      navigator.clipboard.writeText(location.href)
        .then(() => this.copiedURLToClipboard = true)
        .catch(() => this.copiedURLToClipboard = false)
    },
    currentDate() {
      const current = new Date();
      const date = `${current.getFullYear()}-${current.getMonth()+1}-${current.getDate()}`;
      return date;
    },
    statisticCount(type: string)
    {
        postPlaceStatistic(this.$store, {
          place: this.place.id,
          type,
          event: this.$store.state.selectedEvent && this.$store.state.selectedEvent.id || null,
          transmission_type: this.place.transmission_type || 0
        }).catch(() => {})
    },
    openFacebookApp() {
      // Attempt to open the Facebook app
      window.location.href = "fb://page/" + this.place.facebook_page_id;

      // Fallback to the web version in a new tab after a short delay
      setTimeout(() => {
        window.open(this.place.facebook, "_blank");
      }, 1000);
    }
  }
})
